export default __webpack_public_path__ + "static/media/office.0ec1146b.svg";